import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import LinkArrow from "../../assets/arrow-btn.svg";

const Button = ({
  link,
  target = "_self",
  onClick,
  children,
  type,
  form,
  disabled,
  className,
  px = "px-64px",
  variant,
  arrow = false,
  arrowRotated = false,
  arrowRightSide = false,
  arrowClassName,
  buttonClassName,
  boxShadowEnabled,
}) => {
  if (link) {
    return (
      <Link
        to={link}
        target={target}
        className={classNames(
          "flex flex-row items-center justify-center mt-24px py-16px",
          { "opacity-50 cursor-default": disabled },
          className,
        )}
      >
        <div
          className={classNames(
            "w-full h-full md:w-fit px-0 py-18px leading-[130%] text-center hover:brightness-95 capitalize button-text",
            {
              "bg-beige text-blue": variant === "beige",
              "bg-gold text-white": variant === "gold",
              "bg-blue text-white": variant === "blue",
              "bg-cream-white text-blue": variant === "white-blue",
              "bg-white text-gold": variant === "white-gold",
              "bg-transparent text-white": variant === "transparent",
              "flex justify-center items-center": arrow,
            },
            buttonClassName && buttonClassName,
          )}
          style={{
            boxShadow: boxShadowEnabled ? "8px 8px 14px 0 rgba(0, 0, 0, 0.1)" : "",
          }}
        >
          {!arrowRightSide && arrow && (
            <div
              className={classNames(
                "h-full !py-16px !px-20px bg-dark-blue flex items-center justify-center",
                px,
                arrowClassName && arrowClassName,
              )}
            >
              <img
                src={LinkArrow}
                alt="Link Arrow"
                className="w-12px max-w-12px shrink-0"
                style={{ rotate: arrowRotated ? "90deg" : "" }}
              />
            </div>
          )}

          <div className={classNames(px)}>{children}</div>

          {arrowRightSide && arrow && (
            <div
              className={classNames(
                "h-full !py-16px !px-20px bg-dark-blue flex items-center justify-center",
                px,
                arrowClassName && arrowClassName,
              )}
            >
              <img src={LinkArrow} alt="Link Arrow" className="w-12px max-w-12px shrink-0" />
            </div>
          )}
        </div>
      </Link>
    );
  }

  return (
    <button
      onClick={onClick}
      type={type || "text"}
      form={form}
      disabled={disabled}
      className={classNames(
        "flex flex-row items-center justify-center mt-24px",
        { "opacity-50 cursor-default": disabled },
        className,
      )}
      style={{
        boxShadow: boxShadowEnabled ? "8px 8px 14px 0 rgba(0, 0, 0, 0.1)" : "",
      }}
    >
      <div
        className={classNames(
          "w-full md:w-fit leading-[130%] py-18px text-center hover:brightness-95 duration-200 capitalize button-text",
          {
            "bg-beige text-blue": variant === "beige",
            "bg-gold text-white": variant === "gold",
            "bg-blue text-white": variant === "blue",
            "bg-cream-white text-blue": variant === "white-blue",
            "bg-white text-gold": variant === "white-gold",
            "bg-transparent text-white": variant === "transparent",
            "flex justify-center items-center": arrow,
          },
          buttonClassName,
        )}
        style={{
          boxShadow: boxShadowEnabled ? "8px 8px 14px 0 rgba(0, 0, 0, 0.1)" : "",
        }}
      >
        {!arrowRightSide && arrow && (
          <div
            className={classNames(
              "h-full !py-16px !px-20px bg-dark-blue flex items-center justify-center",
              px,
              arrowClassName && arrowClassName,
            )}
          >
            <img
              src={LinkArrow}
              alt="Link Arrow"
              className="w-12px max-w-12px shrink-0"
              style={{ rotate: arrowRotated ? "90deg" : "" }}
            />
          </div>
        )}

        <div className={classNames(px)}>{children}</div>

        {arrowRightSide && arrow && (
          <div
            className={classNames(
              "h-full !py-16px !px-20px bg-dark-blue flex items-center justify-center",
              px,
              arrowClassName && arrowClassName,
            )}
          >
            <img src={LinkArrow} alt="Link Arrow" className="w-12px max-w-12px shrink-0" />
          </div>
        )}
      </div>
    </button>
  );
};

export default Button;
